module.exports = __webpack_public_path__ + "static/media/ABDULSALAM TEMIR.25421b6b.png";